'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropertyTrialId = undefined;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _getTrialId = require('self-service-api/api/getTrialId');

var _createProperty = require('ui-addon-upgrades/_core/common/data/upgradeData/transformers/createProperty');

var _sources = require('ui-addon-upgrades/_core/common/data/upgradeData/properties/sources');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TRIAL_BUTTON = _sources.sourceKeys.TRIAL_BUTTON;

var PROPERTY_KEY = 'trialId';

var getPropertyTrialId = exports.getPropertyTrialId = function getPropertyTrialId(_ref, upgradeSource, props) {
  var upgradeProduct = _ref.upgradeProduct;

  if (upgradeSource !== TRIAL_BUTTON || !upgradeProduct) {
    return _q2.default.Promise.resolve({});
  }

  if (props.trialId && typeof props.trialId === 'number') {
    return (0, _createProperty.createProperty)(PROPERTY_KEY, props.trialId);
  }

  return (0, _getTrialId.getTrialId)(upgradeProduct).then(function (trialId) {
    return (0, _createProperty.createProperty)(PROPERTY_KEY, trialId || null);
  }).catch(function () {
    _devLogger2.default.warn({
      message: 'getPropertyTrialId: Trials API call failed'
    });
    return null;
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/data/upgradeData/transformers/getPropertyTrialId.js
// module id = 450
// module chunks = 3 4 5